import { useSelector } from 'react-redux';

import { currentOpenChatSelector, isShowSubAgentChatListSelector, userIdSelector } from '../../../selectors';
import { EChatRole } from '../../../types/userData';

export enum EUserColor {
  Initial = 'initial',
  Dark = 'dark',
  Purple = 'purple',
  Plum = 'plum',
}

export const useUserColor = (messageUserId: number): EUserColor => {
  const userId = useSelector(userIdSelector);
  const { users = [] } = useSelector(currentOpenChatSelector) || {};
  const isShowSubAgentChatList = useSelector(isShowSubAgentChatListSelector);

  const currentUser = users.find(user => user.userId === userId);
  const messageUser = users.find(user => user.userId === messageUserId);

  const hasCompanion = users.some(user => user.chatRole === EChatRole.Companion);

  // Я - компаньон. Чужие имена - чёрные, мое имя - всегда черное
  if (currentUser?.chatRole === EChatRole.Companion || messageUser?.chatRole === EChatRole.Companion) {
    return EUserColor.Dark;
  }

  // Я - инициатор. Компаньон - чёрный.
  // Оппонент и мастер - сливовые, если есть компаньон
  if (currentUser?.chatRole === EChatRole.Initiator) {
    if (messageUser?.chatRole === EChatRole.Master && hasCompanion) {
      return EUserColor.Plum;
    }

    if (messageUser?.chatRole === EChatRole.Opponent && hasCompanion) {
      return EUserColor.Plum;
    }

    return EUserColor.Initial;
  }

  // Я - мастер (участник или смотрю чат субагента). Компаньон - чёрный, оппонент - пурпурный.
  // Инициатор сливовый, если есть компаньон.
  if (currentUser?.chatRole === EChatRole.Master || isShowSubAgentChatList) {
    if (messageUser?.chatRole === EChatRole.Opponent) {
      return EUserColor.Purple;
    }

    if (messageUser?.chatRole === EChatRole.Initiator && hasCompanion) {
      return EUserColor.Plum;
    }
  }

  // Я - оппонент. Компаньон - чёрный, мастер - пурпурный.
  // Инициатор сливовый, если есть компаньон.
  if (currentUser?.chatRole === EChatRole.Opponent) {
    if (messageUser?.chatRole === EChatRole.Master) {
      return EUserColor.Purple;
    }

    if (messageUser?.chatRole === EChatRole.Initiator && hasCompanion) {
      return EUserColor.Plum;
    }
  }

  return EUserColor.Initial;
};
